<template>    
    <v-badge color="#dd0000" >
      <template v-slot:badge v-if="hasFilter"> 
        <v-menu open-on-hover >
          <span slot="activator">{{nbFiltre}}</span>
          <v-list>
            <v-list-tile>
              <v-btn @click="resetFilter">{{$t('Admin.ResetFilterTooltip')}}<v-icon right>mdi-filter-remove</v-icon></v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <v-icon>mdi-filter</v-icon>
    </v-badge>      
</template>
<script lang="ts" >
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { mapGetters } from 'vuex'  
  import MissionFilter from '@/components/mission/MissionFilter.vue'  
  import { FilterMission } from '@/models/filter/FilterMission'
  @Component({
    name: 'MissionFilterIcon',
      components: {MissionFilter},
      computed: { 
        ...mapGetters([          
          'filterMission'
        ])
      }
  })
  export default class MissionFilterIcon extends Vue {        
    
    filterMission!:FilterMission    

    get hasFilter() {
      return this.nbFiltre > 0
    }

    get nbFiltre(){
      return (this.filterMission.search.length > 0?1:0) 
        + this.filterMission.fleetIds.length 
        + this.filterMission.gliderIds.length 
        + this.filterMission.alarmIds.length 
        + (this.filterMission.onGoing?1:0) 
        + (this.filterMission.simulated?1:0) 
    }

    resetFilter() {
      this.$store.myActions.MISSION_RESET_FILTER()
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
